import DisputeDetail from '@/Component/Admin/Disputes/DisputeDetail';

const DisputeDetailPage = async ({ params }: { params: Promise<{ slug: string }>; }) => {
    const resolvedParams = await params;
    const slug = Array.isArray(resolvedParams.slug)
        ? resolvedParams.slug[0]
        : resolvedParams.slug;

    return slug && <DisputeDetail slug={slug} />;
};

export default DisputeDetailPage;
